import { Modal } from "antd";
import React, { ReactNode } from "react";
type CustomModalProps = {
  visible?: boolean;
  onCancel: any;
  title?: ReactNode | string;
  body?: ReactNode | string;
  height?: string;
  width?: string;
  header?: boolean;
  menuDropdown?: ReactNode | boolean;
  footer?: ReactNode | boolean;
  mask?: boolean;
  maskStyle?: any;
  maskClosable?: boolean;
  style?: React.CSSProperties;
  centered?: boolean;
  wrapClassName?: string;
};

const CustomModal = ({
  visible = false,
  onCancel,
  title,
  body,
  footer,
  height,
  width,
  header,
  menuDropdown,
  mask,
  maskStyle,
  style,
  centered = true,
  wrapClassName,
  maskClosable = true,
}: CustomModalProps) => {


  const handleCancel = (e: any) => {
    onCancel(e);
  };

  return (
    <Modal
      open={visible}
      mask={mask}
      maskStyle={maskStyle}
      maskClosable={maskClosable}
      centered={centered}
      width={width}
      destroyOnClose
      keyboard
      onCancel={handleCancel}
      style={style}
      wrapClassName={wrapClassName}
      modalRender={() => (
        <div
          className="w-full h-full bg-white rounded-xl shadow-md"
          style={{
            pointerEvents: "all",
            maxWidth: width,
            maxHeight: height,
          }}
        >
          {body}
        </div>
      )}
    />
  );
};

export default CustomModal;